module.exports = __webpack_public_path__ + "static/media/ETVOC_OUTOFRANGE.3164ed20.png";